import Content from '../contact-page-component/Content';

export default function Contact ({handleClick, copyText}) {
    return (
        <>
            <Content handleClick={handleClick} copyText={copyText}/>
        </>
    );
}